import { FormGroup } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable()
export class FormService {

  public validators: Object;

  constructor() { }

  public buildForm (controls, validators) {
    this.validators = validators;
    let form: FormGroup = new FormGroup(controls);

    for (let control in validators) {
      form.controls[control].setValidators(validators[control]);
    }

    return form;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/form.service.ts